module.exports = __webpack_public_path__ + "static/media/bg.721ccb58.jpg";